<section class="playground">
  <h2 class="playground__heading">Icon area card</h2>
  <p class="playground__hint">
    <code>common-icon-area-card</code> — estados <code>default</code>/<code>selected</code>, icono/imagen y click.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>title</span>
        <input type="text" [(ngModel)]="title" />
      </label>

      <label class="playground__field">
        <span>status</span>
        <select [(ngModel)]="status">
          <option *ngFor="let s of statuses" [value]="s">{{ s }}</option>
        </select>
      </label>

      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>

      <label class="playground__field">
        <span>imageUrl (opcional)</span>
        <input type="text" [(ngModel)]="imageUrl" placeholder="https://..." />
      </label>

      <label class="playground__field">
        <span>icon (fallback si no hay imageUrl)</span>
        <input type="text" [(ngModel)]="icon" placeholder="sports_basketball" />
      </label>

      <label class="playground__field">
        <span>iconSet</span>
        <select [(ngModel)]="iconSet">
          <option *ngFor="let s of iconSets" [value]="s">{{ s }}</option>
        </select>
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Preview</p>
      <div class="playground__preview-box">
        <common-icon-area-card
          [title]="title"
          [status]="status"
          [disabled]="disabled"
          [imageUrl]="imageUrl || undefined"
          [icon]="icon || undefined"
          [iconSet]="iconSet"
          (select)="onSelect()"
        ></common-icon-area-card>
      </div>

      <p *ngIf="lastEvent" class="playground__meta">{{ lastEvent }}</p>
    </div>
  </div>
</section>

